import React, { useState, useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useIdleTimer } from 'react-idle-timer';
import ChangePasswordSetting from './components/ChangePasswordSetting/ChangePasswordSetting';
import CustomerProfile from './components/Customer/CustomerProfile';
import CustomerUsage from './components/Customer/CustomerUsage';
import CustomerVideomail from './components/Customer/CustomerVideomail';
import VideoPlayer from './pages/VideoPlayer';
import IdleTimeOutModal from './components/IdleTimeOutModal/IdleTimeOutModal';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import GuestUserRegistration from './components/GuestUserRegistration/GuestUserRegistration';
import OAuth2RedirectHandler from './components/oauth2/OAuth2RedirectHandler';
import Policy from './components/Policy/Policy';
import ResetPassword from './components/ResetPassword/ResetPassword';
import VerifyCustomerEmail from './pages/VerifyCustomerEmail';
import { idleTimeOut, logoutTimeAfterModal } from './config/common.constants';
import { LOGOUT } from './store/auth/types';
import BusinessListDirectory from './components/BusinessListDirectory/BusinessListDirectory';
import Home from './pages/Home';
import Room from './pages/Room';
import Permissions from './pages/Permissions';
import Login from './pages/Login';
import B2BUsageReport from './components/B2BUsageReport/B2BUsageReports';
import VideoRecorderPage from './components/VideoMail/VideoRecorderPage/VideoRecorderPage';

const Routes = () => {
    const [idletimer, setIdleTimer] = useState({
        showModal: false,
    });
    const dispatch = useDispatch();
    let warnTimeoutId: any;

    const handleOnAction = () => {};

    const handleOnActive = () => {};

    const handleOnIdle = () => {
        if (!idletimer.showModal) {
            setIdleTimer({ showModal: true });
        }
    };
    const handleLogout = () => {
        dispatch({ type: LOGOUT });
        setIdleTimer({ ...idletimer, showModal: false });
    };

    const { reset } = useIdleTimer({
        timeout: idleTimeOut,
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        onAction: handleOnAction,
    });

    useEffect(() => {
        const handleTimeout = () => {
            if (idletimer.showModal) {
                handleLogout();
            }
        };
        if (!idletimer.showModal) {
            if (warnTimeoutId) clearTimeout(warnTimeoutId);
        } else {
            warnTimeoutId = setTimeout(handleTimeout, logoutTimeAfterModal);
        }
        return () => clearTimeout(warnTimeoutId);
    }, [idletimer, warnTimeoutId]);

    const handleClose = () => {
        reset();
        setIdleTimer({ showModal: false });
    };

    return (
        <BrowserRouter basename={`${process.env.PUBLIC_URL}`}>
            <RouterRoutes>
                <Route path="/home" element={<Home />} />
                <Route path="/usage" element={<CustomerUsage />} />
                <Route path="/profile" element={<CustomerProfile />} />
                <Route path="/changepasswordsetting" element={<ChangePasswordSetting />} />
                <Route path="/video-mail" element={<CustomerVideomail />} />
                <Route path="/b2b-usage" element={<B2BUsageReport />} />
                <Route path="/videoPlayer/*" element={<VideoPlayer />} />
                <Route path="/login" element={<Login />} />
                <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler />} />
                <Route path="/verifyCustomerEmail" element={<VerifyCustomerEmail />} />
                <Route path="/forgotpassword" element={<ForgotPassword />} />
                <Route path="/resetpassword" element={<ResetPassword />} />
                <Route path="/guestuserregistration" element={<GuestUserRegistration />} />
                <Route path="/policy" element={<Policy />} />
                <Route path="/community-directory" element={<BusinessListDirectory />} />
                <Route path="/room" element={<Room />} />
                <Route path="/permissions" element={<Permissions />} />
                <Route path="/VideoRecording/*" element={<VideoRecorderPage />} />
                <Route path="*" element={<Navigate to="/home" replace />} />
            </RouterRoutes>
            {idletimer.showModal && (
                <IdleTimeOutModal
                    showModal={idletimer.showModal}
                    handleClose={handleClose}
                    handleLogout={handleLogout}
                />
            )}
        </BrowserRouter>
    );
};

export default Routes;
